module.exports = __webpack_public_path__ + "static/media/insuranceLogo.2b30e04b.svg";